import { IInitialisable } from "../../../interfaces/IInitialisable";
import { itemConfigs } from "./items";

declare global {
  interface Window {
    hstDesignSystemPreloadNodeNames: string[];
  }
}

export class Bootstrap implements IInitialisable {

  protected observerHelper: MutationObserver | undefined;
  protected documentHelper = document;

  private handleConfigs = itemConfigs;

  constructor() {
    this.mutationCallback = this.mutationCallback.bind(this);
    this.handleNodeAdded = this.handleNodeAdded.bind(this);
  }

  // Tested
  Init(): void {
    this.getPreloadNodeNames().forEach(async nodeName => this.loadBundleAsync(nodeName));
    this.documentHelper.querySelectorAll('*').forEach(el => this.handleNodeAdded(el));
    this.observerHelper = new MutationObserver(this.mutationCallback);
    this.observerHelper.observe(document, { subtree: true, childList: true });
  }

  // Tested
  private mutationCallback(mutations: MutationRecord[], _observer: MutationObserver) {
    const addedNodes = mutations.map(mutation => Array.from(mutation.addedNodes)).reduce((prev, next) => [...prev, ...next], []);
    addedNodes.forEach(this.handleNodeAdded);
  }

  // Tested
  private async handleNodeAdded(el: Node) {
    this.loadBundleAsync(el.nodeName);
  }

  // Tested
  private async loadBundleAsync(nodeName:string) {
    this.handleConfigs.forEach(async config => {
      if (config.nodeName.toLowerCase() === nodeName.toLowerCase() && config.shouldImport === true) {
        config.shouldImport = false;
        await config.asyncImport();
      }
    });
  }

  // Tested
  private getPreloadNodeNames(){
    if(Array.isArray(window.hstDesignSystemPreloadNodeNames) === false){
      return [];
    }
    return window.hstDesignSystemPreloadNodeNames.filter(x => typeof x === 'string');
  }
}